































































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import Layout from '@/components/Layout.vue';
import TagList from '@/components/Money/TagList.vue';
import {
    entertainmentTags,
    foodTags,
    houseTags,
    medicalTags,
    shoppingTags,
    transportTags
} from '@/constants/defaultTags';
import Icon from '@/components/Icon.vue';
import clone from '@/lib/clone';

@Component({
    components: {Icon, TagList, Layout}
})
export default class Label extends Vue {
    tag: TagItem = {name: 'food', value: '餐饮'};
    foodTags = foodTags;
    shoppingTags = shoppingTags;
    transportTags = transportTags;
    houseTags = houseTags;
    entertainmentTags = entertainmentTags;
    medicalTags = medicalTags;

    get tagList() {
        return this.$store.state.tagList;
    }

    back() {
        this.$router.replace('/money');
    }

    ok() {
        this.$store.commit('insertTag', clone(this.tag));
        if (this.$store.state.tagListError === 'duplicate') {
            window.alert('不可添加同名的标签类别');
        } else {
            this.$router.replace('/money');
        }
    }
}
